<template>
  <div>
    <SignUp></SignUp>
  </div>
</template>

<script>
import SignUp from "../components/SingUp.vue";
export default {
  name: 'SignUpView',
  components: {
    SignUp
  }
}
</script>